import { LayerItem, RootState } from '@/types';
import { MapLayerState } from '@/types';
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { layers, choroplethLayers } from '@/assets/data/mapLayers';
import {
  ChoroplethLayerOptionScenarioType,
  ChoroplethLayerOptionType,
} from '@/types/modules/MapLayerTypes.type';
import { cloneDeep } from 'lodash';

const state: MapLayerState = {
  menuItems: layers,
  choroplethLayers,
  selectedChoroplethLayer: {
    selectedLayer: choroplethLayers[0],
    scenario: 'a',
  },
};

const getters: GetterTree<MapLayerState, RootState> = {
  menuItems: state => state.menuItems,
  choroplethLayers: state => state.choroplethLayers,
  selectedChoroplethLayer: state => state.selectedChoroplethLayer,
  choroplethViz: state => {
    const layer = cloneDeep(state.selectedChoroplethLayer);
    const layerKey =
      layer.selectedLayer.options.length > 0
        ? `${layer.selectedLayer.id}-${layer.selectedLayer.options[0].value}`
        : layer.selectedLayer.id;

    layer.selectedLayer.options = layer.selectedLayer.options.filter(
      (option: { label: string; value: string }) =>
        option.value === layer.scenario,
    );

    layer.selectedLayer.key = layerKey;

    return layer.selectedLayer;
  },
};

const mutations: MutationTree<MapLayerState> = {
  setMenuItems: (state, newVal) => {
    state.menuItems = newVal;
  },

  setLayerSelection: (
    state,
    updateInfo: {
      layerItem: LayerItem;
      updateType: 'check' | 'radio';
      radioValue: string | undefined;
    },
  ) => {
    const layerItemToUpdate = state.menuItems.find(
      layerItem => layerItem.title === updateInfo.layerItem.title,
    );
    if (layerItemToUpdate && updateInfo.updateType === 'check') {
      layerItemToUpdate.selected = !layerItemToUpdate.selected;
    }
  },
  setSelectedChoroplethLayer: (state, layer: ChoroplethLayerOptionType) => {
    state.selectedChoroplethLayer.selectedLayer = layer;
  },
  setSelectedChoroplethLayerScenario: (
    state,
    scenario: ChoroplethLayerOptionScenarioType,
  ) => {
    state.selectedChoroplethLayer.scenario = scenario;
  },
};

const actions: ActionTree<MapLayerState, RootState> = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
